import { forwardRef, Ref } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Nav as ArcNav, NavProps } from 'arc';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { DEFAULT_FR_NAV_STYLES } from './constants';

export const Nav = forwardRef(function (props: NavProps, ref?: Ref<HTMLDivElement>) {
    const { isFirstResponder } = useApplicationType();
    const { style, children, ...remainingProps } = props;

    return (
        <ArcNav
            ref={ref}
            style={{
                ...(isFirstResponder ? DEFAULT_FR_NAV_STYLES : {}),
                ...style,
            }}
            {...remainingProps}
        >
            {children}
        </ArcNav>
    );
});
